var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 11.6667V8.33341C18.334 5.19071 18.334 3.61937 17.3577 2.64306C16.3814 1.66675 14.81 1.66675 11.6673 1.66675H10.0007C6.85795 1.66675 5.28661 1.66675 4.31029 2.64306C3.33398 3.61937 3.33398 5.19071 3.33398 8.33341V11.6667C3.33398 14.8094 3.33398 16.3808 4.31029 17.3571C5.28661 18.3334 6.85795 18.3334 10.0007 18.3334H11.6673C14.81 18.3334 16.3814 18.3334 17.3577 17.3571C18.334 16.3808 18.334 14.8094 18.334 11.6667Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82077 8.33333H12.6779C13.5758 8.33333 14.0248 8.33333 14.3038 8.08926C14.5827 7.84518 14.5827 7.45234 14.5827 6.66667C14.5827 5.88099 14.5827 5.48816 14.3038 5.24408C14.0248 5 13.5758 5 12.6779 5H9.82077C8.92285 5 8.47393 5 8.19497 5.24408C7.91602 5.48816 7.91602 5.88099 7.91602 6.66667C7.91602 7.45234 7.91602 7.84518 8.19497 8.08926C8.47393 8.33333 8.92285 8.33333 9.82077 8.33333Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 5H1.66602M4.16602 10H1.66602M4.16602 15H1.66602",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingType);
export default __webpack_public_path__ + "static/media/booking-type.62781e84b7668df8756a58fe7c3e4331.svg";
export { ForwardRef as ReactComponent };